import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class AudiogramComparisonPageLeaveDataService {
  private sharedValue: any;
  private sharedPage: any;
  private saveAudiogramComparisonParams: any= {};
  constructor(
      public apiService: ApiService
  ) { }

  setValue(value: any, page: any): void {
      this.sharedValue = value;
      this.sharedPage = page;
  }

  getValue(): any {
      let sharedData: any = {
          value: this.sharedValue,
          page: this.sharedPage
      }
      return sharedData;
  }

  sendParams(requestParams: {}): any {
      this.saveAudiogramComparisonParams = requestParams;
  }
    
  public saveParams(): any {
    return this.apiService.postService('nihl/audiometry/update', this.saveAudiogramComparisonParams);      
  }
}
